<h2 mat-dialog-title>Save Coordinates</h2>

<mat-dialog-content>
  <!-- Form with formGroup -->
  <form [formGroup]="updateCatalogCords">
    <!-- ID Input Field at the Top -->
    <mat-form-field *ngIf="data.showInput">
      <input 
        matInput 
        formControlName="id"
        required
        
      >
      <mat-error *ngIf="updateCatalogCords.get('id').invalid && updateCatalogCords.get('id').touched">
        ID is required.
      </mat-error>
    </mat-form-field>
    
    <!-- Message Display -->
    <p>{{ data.message }}</p>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="onCancel()" class="cancelButton">Cancel</button>
  <button mat-button (click)="onConfirm()" class="SaveButton">Save</button>
</mat-dialog-actions>
